import { beSendGoGetFailedSendings } from 'Api/beSendGoApi'
import {
  beMessApiGetAllMessages,
  beMessGetMessageMinimumDetails
} from 'Api/BeMessApi'
import {
  beABTestGetAbTestList,
  beABTestGetAggregateReport,
  beABTestGetRecoverable,
  beABTestUpdateRecover,
  beABTestDeleteAbTest
} from 'Api/beABTestApi'
import { storeGet } from 'Helpers/localStorage'
import { STORE_KEY_ID_LIST } from 'Constants'
import { INPUT_MESSAGES_MAX_ITEMS } from 'Constants/'

export async function getFailedSendings (params) {
  const result = beSendGoGetFailedSendings(params)
  return result
}

export async function getABTestList (params) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beABTestGetAbTestList(idList, params)
  return result
}

export async function getAggregateReport (idAbTest) {
  const result = await beABTestGetAggregateReport(idAbTest)
  return { ...result, idAbTest, type: 'aggregate' }
}

export async function getRecoverable (idAbTest) {
  const result = await beABTestGetRecoverable(idAbTest)
  return { value: result, idAbTest, type: 'recoverable' }
}

export async function updateRecover (idAbTest) {
  const result = beABTestUpdateRecover(idAbTest)
  return result
}

export async function deleteAbTest (idAbTest) {
  const result = beABTestDeleteAbTest(idAbTest)
  return result
}

export async function getMessageMinimumDetails (idMessage) {
  const result = beMessGetMessageMinimumDetails(idMessage)
  return result
}

export async function getMessagesList (searchString, orderBy) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  let filterBy
  if (searchString) {
    filterBy = !isNaN(searchString)
      ? `Subject.Contains('${searchString}') || Id==${searchString}`
      : `Subject.Contains('${searchString}')`
  }
  const { Items, TotalItems } = await beMessApiGetAllMessages(
    idList,
    filterBy,
    orderBy,
    1,
    INPUT_MESSAGES_MAX_ITEMS
  )

  return {
    count: TotalItems,
    items: Items.map(({ Id: id, Subject: subject }) => ({ id, subject }))
  }
}
